$(function() {

    $(".subnav__link:not('.subnav__link--inside')").on("mouseenter", function(event) {
        let $this = $(this);

        $(".subnav__inside").removeClass("show");

        if($this.hasClass('has-subnav')) {
            let currentSubnav = $this.nextAll(".subnav__inside");
            currentSubnav.addClass("show");
        }
    });


    $(".nav__subnav-toggle").on("click", function(event) {
        let $this = $(this);
        let currentSubnav = $this.nextAll(".mobile-toggle");

        $this.toggleClass("active");
        currentSubnav.toggleClass("show");
    });


    $(window).on("resize", function() {
        $(".nav__subnav-toggle, .sidebar__form").removeClass("active");
        $(".subnav, .subnav__inside").removeClass("show");

        $(".blocker").remove();
        $("body").removeClass("no-scroll");
    });

});